import { useState } from "react";
import { FloatingChatBubble } from "./FloatingChatBubble";
import { ChatPanel } from "./ChatPanel";

export const FlorenciaChat = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => setIsOpen(prev => !prev);
  const closeChat = () => setIsOpen(false);

  return (
    <>
      <FloatingChatBubble isOpen={isOpen} onClick={toggleChat} />
      <ChatPanel isOpen={isOpen} onClose={closeChat} />
    </>
  );
};
